<script setup>
import { Heading } from '@codinglabsau/ui'

defineProps({
  title: String,
})
</script>

<template>
  <Heading>
    <div class="flex items-center" aria-label="heading">
      <h1 class="font-serif text-2xl font-bold leading-6 text-stone-600 md:text-3xl">
        <slot>
          {{ title }}
        </slot>
      </h1>
    </div>

    <template #actions>
      <slot name="actions" />
    </template>
  </Heading>
</template>
